import { AconexOauthResponse } from '../model/entities';
import { basicProxyApiAxios } from './CustomAxios';

class AconexApi {
    getToken = async (code: string, codeVerifier: string): Promise<AconexOauthResponse> => {
        const response = await basicProxyApiAxios.post<AconexOauthResponse>('/aconex/access-tokens', {
            code,
            codeVerifier,
        });
        return response.data;
    };

    refreshToken = async (refreshToken: string): Promise<AconexOauthResponse> => {
        const response = await basicProxyApiAxios.post<AconexOauthResponse>('/aconex/refresh-tokens', refreshToken);
        return response.data;
    };
}

const aconexApi: AconexApi = new AconexApi();
export default aconexApi;
